<template>
  <div>
    <el-dialog
      :visible="!!editingProject"
      title="查看门派"
      width="1000px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="130px">
        <el-form-item label="门派名称">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input
                :disabled="detailType !== 'detail'"
                v-model="detail.name.zh"
                placeholder="中文名称"
              ></el-input>
            </el-col>
            <el-col :span="6">
              <el-input
                :disabled="detailType !== 'detail'"
                v-model="detail.name.en"
                placeholder="英文名称"
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <div v-if="detailType === 'detail'">
          <el-form-item label="门派logo" prop="leagueLogo">
            <upload
              list-type="picture"
              :drag="false"
              v-model="detail.leagueLogo"
              :data="{ category: 'league' }"
            ></upload>
          </el-form-item>
          <el-form-item label="门派Banner" prop="memberAvatar">
            <upload
              list-type="picture"
              :drag="false"
              v-model="detail.banner"
              :data="{ category: 'league' }"
            ></upload>
          </el-form-item>
          <el-form-item label="门派Banner(移动端)" prop="memberAvatar">
            <upload
              list-type="picture"
              :drag="false"
              v-model="detail.mobileBanner"
              :data="{ category: 'league' }"
            ></upload>
          </el-form-item>
          <el-form-item label="门派背景色">
            <el-input
              v-model="detail.bgColor"
              placeholder="如: #ffffff, rgb(255,255,255)"
            ></el-input>
          </el-form-item>
          <el-form-item label="掌门头像" prop="ownerAvatar">
            <upload
              list-type="picture"
              :drag="false"
              v-model="detail.ownerAvatar"
              :data="{ category: 'league' }"
            ></upload>
          </el-form-item>
          <el-form-item label="成员头像" prop="memberAvatar">
            <upload
              list-type="picture"
              :drag="false"
              v-model="detail.memberAvatar"
              :data="{ category: 'league' }"
            ></upload>
          </el-form-item>
        </div>
        <!-- <div v-if="detailType === 'unlock'">
          <el-form-item label="下次解锁">
            <el-row :gutter="20">
              <el-col :span="7">
                <el-date-picker
                  v-model="detail.nextUnlockStartTime"
                  value-format="timestamp"
                  type="datetime"
                  placeholder="开始时间"
                ></el-date-picker>
              </el-col>
              <el-col :span="7">
                <el-date-picker
                  v-model="detail.nextUnlockEndTime"
                  value-format="timestamp"
                  type="datetime"
                  placeholder="结束时间"
                ></el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>
        </div>
        <el-form-item v-if="['ownerChange', 'ownerConsider'].includes(detailType)" label="掌门价格">
          <el-input-number v-model="detail.ownerPrice" placeholder="FBS"></el-input-number>
        </el-form-item>

        <el-form-item v-if="['ownerChange'].includes(detailType)" label="掌门递增最小价格">
          <el-input-number v-model="detail.ownerPriceStep" placeholder="FBS"></el-input-number>
        </el-form-item>

        <el-form-item v-if="['ownerChange'].includes(detailType)" label="每次竞选延长时间">
          <el-input-number v-model="detail.ownerTimeMinuteStep" placeholder="分钟"></el-input-number>
        </el-form-item>

        <el-form-item v-if="['ownerChange', 'ownerConsider'].includes(detailType)" label="掌门到期时间">
          <el-row :gutter="20">
            <el-col :span="7">
              <el-date-picker
                :disabled="detailType === 'ownerChange'"
                v-model="detail.nextOwnerStartTime"
                value-format="timestamp"
                type="datetime"
                placeholder="续费开始时间"
              ></el-date-picker>
            </el-col>
            <el-col :span="7">
              <el-date-picker
                :disabled="detailType === 'ownerChange'"
                v-model="detail.nextOwnerEndTime"
                value-format="timestamp"
                type="datetime"
                placeholder="续费截止时间"
              ></el-date-picker>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-if="detailType==='ownerChange'" label="下次掌门竞选">
          <el-row :gutter="20">
            <el-col :span="7">
              <el-date-picker
                v-model="detail.nextOwnerChangeTime"
                value-format="timestamp"
                type="datetime"
                placeholder="开始时间"
              ></el-date-picker>
              <div v-if="detailType==='ownerChange'">需要晚于掌门续费截止时间</div>
            </el-col>
            <el-col :span="7">
              <el-date-picker
                v-model="detail.nextOwnerChangeEndTime"
                value-format="timestamp"
                type="datetime"
                placeholder="开始时间"
              ></el-date-picker>
            </el-col>
          </el-row>
        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';

export default {
  name: 'leagueDetail',
  props: ['detailType'],
  data() {
    const validateUnlockEndTime = (rule, value, callback) => {
      if (!this.detail.nextUnlockEndTime) {
        callback();
      }
      if (
        this.detail.nextUnlockStartTime &&
        this.detail.nextUnlockEndTime &&
        value < this.detail.nextUnlockStartTime
      )
        callback(new Error('截止时间不得早于开始时间'));
      callback();
    };

    const validateOwnerEndTime = (rule, value, callback) => {
      if (!this.detail.nextOwnerEndTime) {
        callback();
      }
      if (
        this.detail.nextOwnerStartTime &&
        this.detail.nextOwnerEndTime &&
        value < this.detail.nextOwnerStartTime
      )
        callback(new Error('截止时间不得早于开始时间'));
      callback();
    };

    return {
      dialogVisible: false,
      detail: {
        name: {
          zh: '',
          en: ''
        }
      },
      rules: {
        // coinType: {
        //   required: true,
        //   message: "请填写"
        // },
        // ownerPrice: {
        //   required: true,
        //   message: "请填写"
        // },
        // nextOwnerEndTime: [
        //   {
        //     validator: validateOwnerEndTime,
        //     trigger: "change"
        //   }
        // ],
        // nextUnlockEndTime: [
        //   {
        //     validator: validateUnlockEndTime,
        //     trigger: "change"
        //   }
        // ]
      }
    };
  },
  components: {
    Editor,
    Upload
  },
  watch: {
    editingProject(val) {
      const d = val && { ...val, name: { ...val.name } };
      if (d && !d.name) {
        d.name = {
          zh: '',
          en: ''
        };
      }
      this.detail = d || {
        name: {
          zh: '',
          en: ''
        }
      };
    }
  },
  computed: {
    ...mapState('league', ['editingProject'])
  },
  methods: {
    ...mapActions('league', ['update']),
    ...mapMutations('league', ['setEditingProject']),
    closeDialog() {
      this.$refs['form'].resetFields();
      this.detail = {
        name: {
          zh: '',
          en: ''
        }
      };
      this.setEditingProject(null);
    },

    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.update(this.detail).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh');
      });
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
